'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _ISOBinaryFieldPackager = require('./ISOBinaryFieldPackager');

var _ISOBinaryFieldPackager2 = _interopRequireDefault(_ISOBinaryFieldPackager);

var _LiteralBinaryInterpreter = require('../LiteralBinaryInterpreter');

var _LiteralBinaryInterpreter2 = _interopRequireDefault(_LiteralBinaryInterpreter);

var _NullPrefixer = require('../NullPrefixer');

var _NullPrefixer2 = _interopRequireDefault(_NullPrefixer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @author Sean sean.snow@live.com
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @date 2015/12/25
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */

var IFB_BINARY = function (_ISOBinaryFieldPackag) {
    _inherits(IFB_BINARY, _ISOBinaryFieldPackag);

    function IFB_BINARY(len, description) {
        _classCallCheck(this, IFB_BINARY);

        return _possibleConstructorReturn(this, (IFB_BINARY.__proto__ || Object.getPrototypeOf(IFB_BINARY)).call(this, len, description, _LiteralBinaryInterpreter2.default, _NullPrefixer2.default));
    }

    return IFB_BINARY;
}(_ISOBinaryFieldPackager2.default);

exports.default = IFB_BINARY;


//////////////////
// WEBPACK FOOTER
// ./node_modules/jspos/lib/packer/IFB_BINARY.js
// module id = 80
// module chunks = 0